import {combineReducers} from 'redux';
import DataReducer from "./api/DataReducer";

export default () => {

    const reducerMap = {
        data: DataReducer.reducer,
    };

    return combineReducers(reducerMap);
};
